module.exports = __webpack_public_path__ + "static/media/realme.0ceaf36c.png";